import React, { useEffect, useState } from "react";
import { BidirectionalBar } from "@ant-design/plots";
import { colors } from "../../core/theme";
import DashServices from "../../services/DashServices";

const LineSignedUpPatients = ({ selectedData }) => {
  const [data, setData] = useState([]);
  let [max, setMax] = useState(10);

  useEffect(() => {
    graphicPatientsRegistered();
  }, [selectedData]);

  const graphicPatientsRegistered = async () => {
    try {
      const response = await DashServices.getRegisteredPatients(selectedData);
      if (response.status >= 200 && response.status < 300) {
        const result = response.data.ages;
        let _data = [];
        let _max = 0;
        Object.keys(result)
          .reverse()
          .forEach((k) => {
            _data.push({
              label: k,
              "Pacientes masculinos": result[k]?.masculinos,
              "Pacientes femeninos": result[k]?.femeninos,
            });
            if (result[k].masculinos > _max) {
              _max = result[k].masculinos;
            }
            if (result[k].femeninos > _max) {
              _max = result[k].femeninos;
            }
          });
        setMax(_max);
        setData(_data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const config = {
    data,
    xField: "label",
    yField: ["Pacientes femeninos", "Pacientes masculinos"],
    xAxis: {
      position: "bottom",
    },
    yAxis: {
      "Pacientes femeninos": {
        max: max,
      },
      "Pacientes masculinos": {
        max: max,
      },
    },
    interactions: [
      {
        type: "active-region",
      },
    ],
    tooltip: {
      shared: true,
      showMarkers: false,
    },
    color: [colors.custom_red_70, "#6d9eeb"],
  };
  return <BidirectionalBar {...config} />;
};

export default LineSignedUpPatients;
